export default "__VITE_ASSET__2a7e17fd__"